import React, {Component} from "react";
import styles from "./Warnings.module.scss";
import Config from "config";
import isMobile from "ismobilejs";

export default class Warnings extends Component {
    render() {
        if (isMobile().any) return (
            <div className={styles.warning}>
                <div>
                    <img src={require('images/icons/mobile.svg')} alt="Mobile Device" />
                    <p>Speedweaver is not yet optimised for mobile devices, please use a desktop device.</p>
                    <a href={Config.dashboard} className={styles.btn}>Go Back</a>
                </div>
            </div>
        );

        return (
            <div className={`${styles.warning} ${styles.widthWarning}`}> {/* todo - maybe move this into a separate component. V1 also had a message for IE */}
                <div>
                    <img src={require('images/icons/mobile.svg')} alt="Mobile Device" />
                    <p>Speedweaver is not optimised for small screen sizes. Please increase window width, zoom out or use a device with a larger screen.</p>
                    <a href={Config.dashboard} className={styles.btn}>Go Back</a>
                </div>
            </div>
        );
    }
}